import { useGetUserInfo } from '@modusign/openapi-client-user';
import moment from 'moment';
import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { signOut } from '@app/store/account/sign-out/actions';

export default function useUserIdentificationAndDenyInfo(): {
  isNeedIdentification: boolean;
  identification: {
    identifiedAt: string;
    expiredAt: string | null;
    identificationType: 'MOBILE' | 'MANUAL';
    identifiedName?: string;
    phoneNumber?: string;
  } | null;
  isIdentificationExpired: boolean;
  isApproachIdentificationExpired: boolean;
  isManualIdentified: boolean;
  isDIBlocked: boolean;
  invalidateIdentificationInfo: () => void;
} {
  const currentDate = moment();

  const history = useHistory();
  const dispatch = useDispatch();
  const { data, queryKey } = useGetUserInfo();
  const queryClient = useQueryClient();

  const isIdentificationExpired =
    !!data?.identification &&
    data?.identification.identificationType === 'MOBILE' &&
    !moment(data?.identification.expiredAt).isAfter(currentDate);

  const isNeedIdentification = !data?.identification || isIdentificationExpired;

  const isApproachIdentificationExpired =
    !!data?.identification &&
    data?.identification.identificationType === 'MOBILE' &&
    moment(data?.identification.expiredAt).diff(currentDate, 'days') <= 30;

  const isManualIdentified = data?.identification?.identificationType === 'MANUAL';

  const invalidateIdentificationInfo = useCallback(() => {
    queryClient.invalidateQueries(queryKey);
  }, [queryClient, queryKey]);

  if (data?.blockInfo) {
    dispatch(signOut());
    history.push('/authentication/signin');
  }

  return {
    isNeedIdentification,
    isDIBlocked: !!data?.blockInfo,
    identification: data?.identification || null,
    isIdentificationExpired,
    isApproachIdentificationExpired,
    isManualIdentified,
    invalidateIdentificationInfo,
  };
}
